import React, { useState } from "react";
import { ABtn, AResult, AScore, AHint } from "./arcadeUi";

const rnd = () => 1 + Math.floor(Math.random() * 6);

export default function HandCricket() {
  const [phase, setPhase] = useState("bat"); // bat -> bowl -> over
  const [your, setYour] = useState(0);
  const [cpu, setCpu] = useState(0);
  const [target, setTarget] = useState(null);
  const [last, setLast] = useState(null); // {you, cpu, out}
  const [msg, setMsg] = useState("You bat first! Pick a number.");

  const reset = () => {
    setPhase("bat"); setYour(0); setCpu(0); setTarget(null); setLast(null);
    setMsg("You bat first! Pick a number.");
  };

  const pick = (n) => {
    const c = rnd();
    if (phase === "bat") {
      if (n === c) {
        const t = your + 1;
        setTarget(t); setPhase("bowl"); setLast({ you: n, cpu: c, out: true });
        setMsg(`OUT! You scored ${your}. Now bowl — CPU needs ${t} to win.`);
      } else {
        setYour((v) => v + n); setLast({ you: n, cpu: c, out: false });
        setMsg("Nice shot! Keep going.");
      }
    } else if (phase === "bowl") {
      if (n === c) {
        setPhase("over"); setLast({ you: n, cpu: c, out: true });
        setMsg(`Bowled him! CPU is all out on ${cpu}.`);
      } else {
        const nc = cpu + c;
        setLast({ you: n, cpu: c, out: false });
        if (nc >= target) { setCpu(nc); setPhase("over"); setMsg("CPU chased it down!"); }
        else { setCpu(nc); setMsg("CPU is batting… keep bowling!"); }
      }
    }
  };

  const won = phase === "over" ? (target != null && cpu < target ? true : false) : null;

  return (
    <div className="w-full text-center">
      <div className="flex justify-center gap-2">
        <AScore label="You" value={your} />
        <AScore label="CPU" value={cpu} />
        {target != null && <AScore label="Target" value={target} />}
      </div>

      <AHint>{phase === "bat" ? "🏏 Batting" : phase === "bowl" ? "🎯 Bowling" : "Match over"}</AHint>
      <p data-testid="hc-msg" className="min-h-[1.5rem] font-signboard text-lg text-kirana-brown">{msg}</p>

      {last && (
        <div className="my-3 flex items-center justify-center gap-6 text-4xl">
          <div className="flex flex-col items-center"><span>✋{last.you}</span><span className="text-xs font-bold text-kirana-brown">YOU</span></div>
          <span className="font-signboard text-xl text-kirana-brown/50">vs</span>
          <div className="flex flex-col items-center"><span>✋{last.cpu}</span><span className="text-xs font-bold text-kirana-brown">CPU</span></div>
        </div>
      )}

      {phase !== "over" ? (
        <div className="mt-4 grid grid-cols-3 gap-2 sm:grid-cols-6">
          {[1, 2, 3, 4, 5, 6].map((n) => (
            <ABtn key={n} data-testid={`hc-pick-${n}`} onClick={() => pick(n)} tone="gold" className="text-lg">{n}</ABtn>
          ))}
        </div>
      ) : (
        <>
          <AResult testId="hc-result" win={won} text={won ? "🏆 You Won the Match!" : "😜 CPU Won"} />
          <div className="mt-4 flex justify-center"><ABtn data-testid="hc-again" onClick={reset} tone="green">Play Again</ABtn></div>
        </>
      )}
    </div>
  );
}
